module.exports = __webpack_public_path__ + "static/media/myProperties.3d161118.svg";